import { render, staticRenderFns } from "./CmgUComForm.vue?vue&type=template&id=665c9954&scoped=true&lang=pug"
import script from "./cmg-ucom-form.ts?vue&type=script&lang=ts&external"
export * from "./cmg-ucom-form.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgUComForm.vue?vue&type=style&index=0&id=665c9954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665c9954",
  null
  
)

export default component.exports